export const encodeKey = (key: string): string => {
  return btoa(key.split("").reverse().join(""));
};

const decodeKey = (encodedKey: string): string => {
  return atob(encodedKey).split("").reverse().join("");
};

const getImgbbKey = (): string => {
  const encodedKey = "ZjIwZGYyNzkwMzQzOTEyZGVkMmI2NGQ2NDg0M2Q5YWI="; // Encoded version of your key
  return decodeKey(encodedKey);
};

// 이미지 리사이징 함수
const resizeImage = (
  file: File,
  maxWidth: number = 1920,
  maxHeight: number = 1920,
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Canvas 생성(Dom에 추가하지 않으면, 메모리상에서만 생성이 된다.)
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      reject(new Error("Canvas context not available"));
      return;
    }

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = Math.floor(width * ratio);
        height = Math.floor(height * ratio);
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          // 이미지 로딩 완료 후 Blob URL 해제 (메모리 최적화)
          URL.revokeObjectURL(img.src);
          img.onload = null;
          img.onerror = null;

          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Failed to create blob"));
          }
        },
        "image/webp", // WebP 포맷 사용
        0.8, // 품질 설정 (0.0 ~ 1.0)
      );
    };

    img.onerror = () => {
      // 에러 발생 시에도 Blob URL 해제
      URL.revokeObjectURL(img.src);
      img.onload = null;
      img.onerror = null;
      reject(new Error("Failed to load image"));
    };

    img.src = URL.createObjectURL(file);
  });
};

export const uploadToImgBB = async (
  file: File,
  maxWidth: number = 1280,
  maxHeight: number = 1280,
) => {
  // 이미지 파일인 경우에만 리사이징 (maxWidth와 maxHeight가 모두 0이 아닐 때만)
  let fileToUpload: File | Blob = file;

  if (file.type.startsWith("image/") && !(maxWidth === 0 && maxHeight === 0)) {
    try {
      const resizedBlob = await resizeImage(file, maxWidth, maxHeight);
      // Blob을 File로 변환
      fileToUpload = new File([resizedBlob], file.name, { type: file.type });
    } catch (error) {
      console.warn("Image resize failed, using original:", error);
      // 리사이징 실패 시 원본 사용
    }
  }

  const formData = new FormData();
  formData.append("image", fileToUpload);

  const response = await fetch(
    `https://api.imgbb.com/1/upload?key=${getImgbbKey()}`,
    {
      method: "POST",
      body: formData,
    },
  );

  const data = await response.json();
  return data.data.url;
};
